import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const Paragraph = (props) => {
  const { className, mobileStyling, ...rest } = props;

  const classes = classNames(
    "paragraph",
    { is_mobile_version: mobileStyling },
    className
  );

  return (
    <p className={classes} {...rest}>
      {props.children}
    </p>
  );
};

Paragraph.propTypes = {
  children: PropTypes.any,
  className: PropTypes.any,
  mobileStyling: PropTypes.bool,
};

Paragraph.defaultProps = {
  mobileStyling: false,
};

export default Paragraph;
